<template>
    <div id="hometable">
          <div class="banner">
            <div class="bannerleft" @click="toIndexTable">
              <img src="../../public/images/logo.png" />
              <!-- <h1>Yao28.Com</h1> -->
            </div>
          </div>
          <div class="container container-h">
            <div class="tabView">
              <table class="tabtitle">
                <tr>
                  <td :class="tabIndex == 0 ? 'active' : ''" @click="switchGame(0)">加拿大28</td>
                  <td :class="tabIndex == 1 ? 'active' : ''" @click="switchGame(1)">台湾28</td>
                  <td :class="tabIndex == 2 ? 'active' : ''" @click="switchGame(2)">北京28</td>
                  <td :class="tabIndex == 3 ? 'active' : ''" @click="switchGame(3)">香港28</td>
                </tr>
                <tr>
                  <td :class="showTableIndex == 0 ? 'active' : ''" @click="switchTab(0)">单双</td>
                  <td :class="showTableIndex == 1 ? 'active' : ''" @click="switchTab(1)">大小</td>
                  <td :class="showTableIndex == 2 ? 'active' : ''" @click="switchTab(2)">组合</td>
                  <td :class="showTableIndex == 3 ? 'active' : ''" @click="switchTab(3)">杀组合</td>
                </tr>
            </table>
              <!-- <div :class="tabIndex == 0 ? 'active' : ''" @click="switchGame(0)">
                <span>加拿大28</span>
              </div>
              <div :class="tabIndex == 1 ? 'active' : ''" @click="switchGame(1)">
                <span>台湾28</span>
              </div>
              <div :class="tabIndex == 2 ? 'active' : ''" @click="switchGame(2)">
                <span>北京28</span>
              </div>
              <div :class="tabIndex == 3 ? 'active' : ''" @click="switchGame(3)">
                <span>香港28</span>
              </div>
              <div :class="showTableIndex == 0 ? 'active' : ''" @click="switchTab(0)">
                <span>单双</span>
              </div>
              <div :class="showTableIndex == 1 ? 'active' : ''" @click="switchTab(1)">
                <span>大小</span>
              </div>
              <div :class="showTableIndex == 2 ? 'active' : ''" @click="switchTab(2)">
                <span>组合</span>
              </div>
              <div :class="showTableIndex == 3 ? 'active' : ''" @click="switchTab(3)">
                <span>杀组合</span>
              </div> -->
            </div>
            <div class="centss">
              <div class="topp">
                  当前游戏
                <span class="tlef">{{ tabIndex==0?'加拿大28':tabIndex==1?'台湾28':tabIndex==2?'北京28':tabIndex==3?'香港28':'' }}</span>
                  算法
                <span class="trig">{{ showTableIndex==0?'单双':showTableIndex==1?'大小':showTableIndex==2?'组合':showTableIndex==3?'杀组合':'' }}</span>
              </div>
              <div class="bot">
                <div class="blef">
                    第<span> {{ lastNumInfo.openNum }}</span>期
                </div>
                <div class="bcen">|</div>
                <div class="brig" v-if="showWait">
                  正在开奖...
                </div>
                <div class="brig" v-if="!showWait">
                      还有
                      <b>{{ nextNumTime[0] }}</b>
                      分
                      <b>{{ nextNumTime[1] }}</b>
                      秒
                </div>
              </div>
            </div>
            <div class="bots" >
                <oddevenTable :table-data="tableData" v-if="showTableIndex == 0"></oddevenTable>
                <sizeTable :table-data="tableData" v-if="showTableIndex == 1"></sizeTable>
                <assemblyTable :table-data="tableData" v-if="showTableIndex == 2"></assemblyTable>
                <killcomboTable :table-data="tableData" v-if="showTableIndex == 3"></killcomboTable>
            </div>
          </div>
      </div>
  
  </template>
  
  <script>
  import oddevenTable from './oddevenTable.vue';
  import sizeTable from './sizeTable.vue';
  import assemblyTable from './assemblyTable.vue';
  import killcomboTable from './killcomboTable.vue';

  export default {
    inject: ['reload'],
    name: 'App',
    components: {
      oddevenTable,
      sizeTable,
      assemblyTable,
      killcomboTable,
    },
    data() {
      return {
        tableData: [],
        showTableIndex: 0,
        tabIndex: 0,
        listQuery: {
          pageLimit: 50,
          pageIndex: 1
        },
        lastNumInfo: {
          openNum: "",
          openTime: 0,
          stopBetTime: 0
        },
        nextNumTime: ['--', '--'],
        showWait: false,
        timeHandle: null,
        queryOpenNum: {
          openNum: "",
          result: ["--", '--', '--']
        },
        result: "",
        showResultModel: 0
      }
    },
    created() {
      // localStorage.setItem('mydata',JSON.stringify({tabIndex:this.tabIndex,showTableIndex:this.showTableIndex}))
      // const cachedmydata = JSON.parse(localStorage.getItem('mydata'));
      // console.log(cachedmydata)
      if(this.$route.params.tabi == undefined || this.$route.params.showti == undefined){
        this.tabIndex = 0;
        this.showTableIndex = 0;
      }else{
        this.tabIndex = this.$route.params.tabi;
        this.showTableIndex = this.$route.params.showti;
      }

      if (this.tabIndex == 0) {
          this.getCanada28LastNumInfo()
        } else if (this.tabIndex == 1){
          this.getTaiwan28LastNumInfo()
        } else if (this.tabIndex == 2){
          this.getBeijing28LastNumInfo()
        } else if (this.tabIndex == 3){
          this.getHongKong28LastNumInfo()
        } 
      this.timeHandle = setInterval(this.calcNextTime, 1000);
    },
    destroyed() {
      if (this.timeHandle != null) {
        clearInterval(this.timeHandle);
      }
    },
    methods: {
      toIndexTable(){
        this.$router.push('/');
      },
      calcResult() {
        this.tableData.forEach(item => {
          let sumResult = 0
          item.openTime = this.getdate(item.openTime)
          if (item.result == null || item.result.length == 0) {
            console.log("item.result == null")
          } else {
            item.result.forEach(value => {
              sumResult += value
            })
            item.sumResult = sumResult
          }
        })
      },
      switchTab(tabIndex) {
        this.showTableIndex = tabIndex
      },
      switchGame(tabIndex) {
        this.tabIndex = tabIndex
        this.queryOpenNum = {
          openNum: "",
          result: ["--", '--', '--']
        }
        if (tabIndex == 0) {
          this.getCanada28LastNumInfo()
        } else if (tabIndex == 1){
          this.getTaiwan28LastNumInfo()
        } else if (tabIndex == 2){
          this.getBeijing28LastNumInfo()
        } else if (tabIndex == 3){
          this.getHongKong28LastNumInfo()
        } 
      },

      //台湾
      async getTaiwan28LastNumInfo() {
        let res = await this.$axios.post("https://apis.pcz28.com/api2/taiwan28/getLastNumInfo", {})
        this.lastNumInfo = res.data
        this.queryTaiwan28Result()
      },
      async queryTaiwan28Result() {
            try {
              const response = await fetch("https://apis.pcz28.com/api2/taiwan28/getResultRecord2?pageLimit=50&pageIndex=1");
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              const data = await response.json();
              this.tableData = data.data
              this.queryOpenNum = {
                openNum: "",
                result: ["--", '--', '--']
              }
              if (this.tableData.length > 0) {
                if (this.showResultModel == 1) {
                  this.showResultModel = 0
                  this.$nextTick(() => {
                    this.showResultModel = 1
                    this.queryOpenNum = this.tableData[1]
                  })
                } else {
                  this.queryOpenNum = this.tableData[1]
                }
              }
              this.calcResult(this.tableData);
            } catch (error) {
              console.error('Error fetching data:', error);
            }
      },

      //香港
      async getHongKong28LastNumInfo() {
        let res = await this.$axios.post("https://apis.hkpc28.com/api3/hkong28/getLastNumInfo", {})
        this.lastNumInfo = res.data
        this.queryHongKong28Result()
      },
      async queryHongKong28Result() {
        let res = await this.$axios.post("https://apis.hkpc28.com/api3/hkong28/getResultRecord", this.listQuery)
        this.tableData = res.data
        this.queryOpenNum = {
          openNum: "",
          result: ["--", '--', '--']
        }
        if (this.tableData.length > 0) {
          if (this.showResultModel == 1) {
            this.showResultModel = 0
            this.$nextTick(() => {
              this.showResultModel = 1
              this.queryOpenNum = this.tableData[1]
            })
          } else {
            this.queryOpenNum = this.tableData[1]
          }
        }
        this.calcResult();
      },
      async getBeijing28LastNumInfo() {
        let res = await this.$axios.post("https://apis.hkpc28.com/api/australia28/getLastNumInfo", {})
        this.lastNumInfo = res.data
        this.queryBeijing28Result()
      },
      async queryBeijing28Result() {
        let res = await this.$axios.post("https://apis.hkpc28.com/api/australia28/getResultRecord", this.listQuery)
        this.tableData = res.data
        this.queryOpenNum = {
          openNum: "",
          result: ["--", '--', '--']
        }
        if (this.tableData.length > 0) {
          if (this.showResultModel == 1) {
            this.showResultModel = 0
            this.$nextTick(() => {
              this.showResultModel = 1
              this.queryOpenNum = this.tableData[1]
            })
          } else {
            this.queryOpenNum = this.tableData[1]
          }
        }
     
        this.calcResult();
      },
      async getCanada28LastNumInfo() {
        let res = await this.$axios.post("https://apis.pcz28.com/api/canada28/getLastNumInfo", {})
        this.lastNumInfo = res.data
        this.queryCanada28Result()
      },
      async queryCanada28Result() {
        let res = await this.$axios.post("https://apis.pcz28.com/api/canada28/getResultRecord", this.listQuery)
        this.tableData = res.data
        this.queryOpenNum = {
          openNum: "",
          result: ["--", '--', '--']
        }
        if (this.tableData.length > 0) {
          if (this.showResultModel == 1) {
            this.showResultModel = 0
            this.$nextTick(() => {
              this.showResultModel = 1
              this.queryOpenNum = this.tableData[1]
            })
          } else {
            this.queryOpenNum = this.tableData[1]
          }
        }
        this.calcResult();
      },


      
      calcNextTime() {
        if (this.lastNumInfo.stopBetTime == 0) return
        let time2 = this.lastNumInfo.stopBetTime - (new Date()).valueOf() / 1000
        let time3 = this.lastNumInfo.openTime - (new Date()).valueOf() / 1000
        
        time2 = parseInt(time2)
        if (time3 <= 0) {
          if (this.tabIndex == 0) {
            this.getHongKong28LastNumInfo()
          } else if(this.tabIndex == 1) {
            this.getCanada28LastNumInfo()
          } else if(this.tabIndex == 2) {
            this.getBeijing28LastNumInfo()
          }
        }
        if (time2 <= 0) {
          this.$set(this.nextNumTime, 0, "--")
          this.$set(this.nextNumTime, 1, "--")
          this.showWait = true
          return
        }
        this.showWait = false
        let mTime = parseInt(time2 / 60)
        let sTime = time2 % 60
        if (mTime < 10) mTime = '0' + mTime;
        if (sTime < 10) sTime = '0' + sTime
        this.$set(this.nextNumTime, 0, mTime)
        this.$set(this.nextNumTime, 1, sTime)
  
      },
      handleCommand(command) {
        if (this.showResultModel == 1) {
          this.showResultModel = 0
          this.$nextTick(() => {
            this.showResultModel = 1
            this.queryOpenNum = command
          })
        } else {
          this.$nextTick(() => {
            this.queryOpenNum = command
          })
        }
      },
      getSum() {
        return this.queryOpenNum.result[0] + this.queryOpenNum.result[1] + this.queryOpenNum.result[2]
      },
      isBigNum() {
        if (this.getSum() >= 14) return true
        return false
      },
      isOddNumber() {
        if (this.getSum() == 0 || (this.getSum() % 2 == 0)) return false
        return true
      },
      setModel(model) {
        this.showResultModel = model
      },
      getdate(times) {
        var now = new Date(times * 1000),
          y = now.getFullYear(),
          m = now.getMonth() + 1,
          d = now.getDate();
        return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
      }
    }
  }
  </script>
<style lang="scss" scoped>

.bannerleft{
          cursor: pointer;
          display: flex;
          width: 1.2rem;
          img{
              height: 1.2rem;
          }
          /* h1{
              margin-left: 5px;
              line-height: 36px;
              font-weight: 500;
              font-size: 20px;
          } */
    }
    
  .tabtitle{
    height: 1.5rem;
    border-collapse: collapse;
    tr{
        td{
            cursor: pointer;
            color: #606266;
            text-align: center;
            width: 3.1rem;
            font-size: 0.22rem;
            border: 1px solid #DCDFE6;
        }
        td:hover{
            border: 1px solid #C6E2FF;
            color: #409EFF;
            background-color: #ECF5FF;
        }
        .active {
            background-color: #ECF5FF;
            color: #409EFF;
            border: 0.01rem solid #409EFF;
        }
    }
  }
  .project-dropdown {
  
    height: 300px;
    overflow: auto;
  }
  
  .project-dropdown::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    background-color: #F5F5F5;
  }
  
  .project-dropdown::-webkit-scrollbar-track {
    /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);*/
    border-radius: 10px;
    background-color: #F5F5F5;
  }

  .centss{
    padding: 0.1rem;
    border: 1px solid #DCDFE6;
    height: 1.25rem;
    font-size: 0.25rem;
    text-align: center;
    div{
        line-height: 0.6rem;
        height: 0.6rem;
        span{
            color: white;
            font-size: 0.2rem;
            border-radius: 5px;
            padding: 0.05rem 0.1rem;
            margin: 0.1rem;
        }
        .tlef{
            background-color: #67C23A;
        }
        .trig{
            background-color: #E6A23C;
        }
    }
    .bot{
        display: flex;
        justify-content: center;
        .blef{
            span{
                border-radius: 18px;
                padding: 0.05rem 0.1rem;
                background-color: #909399;
                color: white;
            }
        }
        .bcen{
            width: 0.3rem;
            margin-left: 0.1rem;
            margin-right: 0.1rem;
            color: #DCDFE6;
        }
        .brig{
            font-family: DM Mono,ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;
            b{
                padding: 0.05rem 0.1rem;
                border-radius: 8px;
                color: white;
                background-color: #DC2626;
                font-weight: 400;
            }
        }
    }
}
  </style>
  
  